import React from "react";
import "./ForInfluencers.scss";
import ForInfluencersMain from "./components/ForInfluencersMain";
import ForInfluencersTech from "./components/ForInfluencersTech";
import ForInfluencersRole from "./components/ForInfluencersRole";
import ForInfluencersContent from "./components/ForInfluencersContent";

export const ForInfluencers: React.FC = React.memo(() => {
    return (
        <div className="for-influencers">
            <ForInfluencersMain/>
            <ForInfluencersTech/>
            <ForInfluencersRole/>
            <ForInfluencersContent/>
        </div>
    );
});